import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError, MessageScopeType, MessageService, MessageType } from "@obg/ngx.core";
import { groupSwitchMap } from "@obg/ngx.global";
import { merge, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ContentGroupType } from "../content/content.model";

import { ImageAction } from "./image.action";
import { ImageService } from "./image.service";
/**
 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
 */
@Injectable()
export class ImageEffect {
	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	getAll$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ImageAction.getAll),
			map((x: ActionWithPayload<ContentGroupType>) => x.payload),
			groupSwitchMap((group: ContentGroupType) =>
				this.service.getAll(group).pipe(
					map((response) =>
						ImageAction.getAllSuccess({
							images: response,
							group,
						})
					),
					catchError((error: AppError) => of(ImageAction.getAllFail(error)))
				)
			)
		)
	);

	initMessages$ = createEffect(() =>
		merge(
			this.messageService.mapErrorByContext$(
				{
					[ImageAction.getAllFail.type]: ImageAction.getAll.type,
				},
				MessageScopeType.Global,
				MessageType.Error
			),
			this.messageService.mapClearByContext$({
				[ImageAction.getAll.type]: ImageAction.getAll.type,
			})
		)
	);

	constructor(
		private actions$: Actions,
		private service: ImageService,
		private messageService: MessageService
	) {}
}
